import React, { memo, useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const ImageContainer = styled(Box)({
  width: '63px',
  height: '30px',
  borderRadius: '4px',
  overflow: 'hidden',
  position: 'relative',
  flexShrink: 0,
  backgroundColor: '#f5f5f5',
});

const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const PlaceholderBox = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f5f5f5',
  border: '1px solid #e0e0e0',
  borderRadius: '4px',
});

const PlaceholderIcon = styled(HomeOutlinedIcon)({
  fontSize: '16px',
  color: '#c4c4c4',
});

interface PlaceholderImageProps {
  src?: string | null;
  alt?: string;
  fallbackText?: string;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = memo(({
  src,
  alt = '',
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const showPlaceholder = !src || hasError;

  return (
    <ImageContainer>
      {!showPlaceholder && (
        <StyledImage
          src={src}
          alt={alt}
          onError={() => setHasError(true)}
          onLoad={() => setIsLoaded(true)}
          style={{ display: isLoaded ? 'block' : 'none' }}
        />
      )}
      {(showPlaceholder || !isLoaded) && (
        <PlaceholderBox>
          <PlaceholderIcon />
        </PlaceholderBox>
      )}
    </ImageContainer>
  );
});

PlaceholderImage.displayName = 'PlaceholderImage';

export default PlaceholderImage;
